/**
 * Checks if a product in the current flow (main or upsell) has valid trip data
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct<ProductP2P>(to);
    const { firstStepRoute } = useFlow(to);

    if (product.value.isRoundtrip === true
        && (!product.value.tripUp || !product.value.tripDown)) {
        return navigateTo(firstStepRoute.value);
    }

    if (!product.value.isRoundtrip && !product.value.tripUp) {
        return navigateTo(firstStepRoute.value);
    }
});
